import React, { useCallback, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLangContext } from "../../../../../providers/LangProvider/LangProviderContext";
import { getUserEmailConfirmedSelector, getUserEmailSelector } from "../../../../../app/appSelectors";
import { getUserConfirmEmailLoading, getUserConfirmEmailRequestTime } from "../../../accountSelectors";
import { resendUserConfirmEmailAction } from "../../../accountActions";
import { ProfileButtonEmailTitleStyled } from "./styled/ProfileButtonEmailStyled";
import BinIcon from "../../../../../components/icon/Icon";
import ProfileInfoCard from "../../../../../components/ProfileInfoCard/ProfileInfoCard";
import _ from "lodash";

const ProfileButtonEmail = () => {
    const [isShowEmailConfirmedMessage, setIsShowEmailConfirmedMessage] = useState(false);
    const { getLangPath } = useLangContext();
    const dispatch = useDispatch();
    const confirmEmailRequestTime = useSelector(getUserConfirmEmailRequestTime);
    const userEmail = useSelector(getUserEmailSelector);
    const confirmEmailLoading = useSelector(getUserConfirmEmailLoading);
    const userEmailConfirmed = useSelector(getUserEmailConfirmedSelector);
    const [isDelayInProgress, setIsDelayInProgress] =  useState(false);
    useEffect(() => {
        let timer: NodeJS.Timeout | undefined;
        if (userEmailConfirmed || !confirmEmailRequestTime) {
            return;
        }
        setIsDelayInProgress(true);
        timer = setTimeout(() => {
            setIsDelayInProgress(false);
        }, 30000);
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        }
    }, [userEmailConfirmed, confirmEmailRequestTime]);

    const handleEmailClick = useCallback(() => {
        if (!isShowEmailConfirmedMessage && userEmailConfirmed) {
            setIsShowEmailConfirmedMessage(true);
            setTimeout(() => {
                setIsShowEmailConfirmedMessage(false);
            }, 2000);
        }
    }, [isShowEmailConfirmedMessage, setIsShowEmailConfirmedMessage, userEmailConfirmed]);

    const handleConfirmButtonClick = useCallback(() => {
        dispatch(resendUserConfirmEmailAction());
    }, [dispatch]);

    if (userEmailConfirmed) {
        return (
            <ProfileButtonEmailTitleStyled className="d-flex align-items-center user-email-confirmed" onClick={handleEmailClick}>
                <BinIcon name="IcEnvelope" size="16px" fill="var(--color-label-primary)" />
                <span className={"ms-2"}>{userEmail}</span>
            </ProfileButtonEmailTitleStyled>
        )
    }

    if (isDelayInProgress) {
        return (
            <ProfileInfoCard
                textIcon="IcEnvelope"
                title={userEmail}
                text={getLangPath('sign_up.email_check_inbox')}
                btnText={getLangPath('sign_up.email_link_sent')}
                btnIcon="IcClock"
                onClick={_.noop}
                disabled
            />
        );

    }
    return (
        <ProfileInfoCard
            textIcon="IcEnvelope"
            title={userEmail}
            text={getLangPath('sign_up.email_confirmation_purpose')}
            btnText={getLangPath('sign_up.confirm')}
            btnIcon="IcArrowRight"
            onClick={handleConfirmButtonClick}
            disabled={confirmEmailLoading}
        />
    );
}




export default ProfileButtonEmail;
